export const AUTHORIZATION_SET = 'AUTHORIZATION_SET'
export const AUTHORIZATION_UNSET = 'AUTHORIZATION_UNSET'
export const AUTHORIZATION_UNSET_SUCCESS = 'AUTHORIZATION_UNSET_SUCCESS'
export const AUTHORIZATION_LOAD = 'AUTHORIZATION_LOAD'
export const AUTHORIZATION_SUCCESS = 'AUTHORIZATION_SUCCESS'
export const AUTHORIZATION_FAILED = 'AUTHORIZATION_FAILED'
